import classNames from "classnames";
import * as React from "react";

import TextWithTooltip from "components/table/TextWithTooltip";
import layoutStyle from "styles/layout.scss";
import { formatDateWithoutTime, formatTimestamp } from "utils/format";

const DateCell = (rawProps: {
    value: string[] | string;
    tooltip?: boolean;
    withoutTime?: boolean;
    timeFirst?: boolean;
    testId?: string;
    disabled?: boolean;
    convertToLocal?: boolean;
}): JSX.Element => {
    const props = { tooltip: false, ...rawProps };
    const getContent = (value: string) => {
        return props.tooltip ? <TextWithTooltip text={value} /> : value;
    };

    const values = Array.isArray(props.value) ? props.value : Array.of(props.value);
    return (
        <div className={classNames({ [layoutStyle.disabledContainer]: props.disabled })} data-testid={props.testId}>
            {getContent(
                values
                    .map((singleValue) =>
                        props.withoutTime
                            ? formatDateWithoutTime(singleValue)
                            : formatTimestamp(singleValue, props.timeFirst, props.convertToLocal)
                    )
                    .join("; ")
            )}
        </div>
    );
};

export default DateCell;
